import React, { useState } from 'react';

interface EventDescriptionProps {
  description: string | null | undefined;
}

const COLLAPSE_AFTER_CHARS = 600;

const EventDescription: React.FC<EventDescriptionProps> = ({ description }) => {
  const [expanded, setExpanded] = useState(false);
  if (!description?.trim()) return null;

  const overflows = description.length > COLLAPSE_AFTER_CHARS;
  const shown = !overflows || expanded
    ? description
    : `${description.slice(0, COLLAPSE_AFTER_CHARS).trimEnd()}…`;

  return (
    <div className="text-sm text-text-secondary whitespace-pre-line break-words">
      {shown}
      {overflows && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="ml-1 text-primary-500 font-medium hover:underline"
        >
          {expanded ? 'Show less' : 'Show more'}
        </button>
      )}
    </div>
  );
};

export default EventDescription;
